const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function eventCountdownLabel(startsAt: string, now = new Date()) {
  const start = new Date(startsAt).getTime();
  if (!Number.isFinite(start)) return "Event time unavailable";
  const remaining = start - now.getTime();
  if (remaining <= -20 * MINUTE) return "Event has passed";
  if (remaining <= 0) return "Starting now";
  if (remaining > DAY) {
    const days = Math.ceil(remaining / DAY);
    return `Starts in ${days} ${days === 1 ? "day" : "days"}`;
  }
  if (remaining > HOUR) {
    const hours = Math.ceil(remaining / HOUR);
    return `Starts in ${hours} ${hours === 1 ? "hour" : "hours"}`;
  }
  const minutes = Math.max(2, Math.ceil(remaining / (2 * MINUTE)) * 2);
  return `Starts in ${minutes} minutes`;
}

export function detailedEventDistance(startsAt: string, now = new Date()) {
  const start = new Date(startsAt).getTime();
  if (!Number.isFinite(start)) return "Check the event time";
  const difference = start - now.getTime();
  if (difference <= -20 * MINUTE) return "This event has passed";
  if (difference <= 0) return "Starting now";
  const totalMinutes = Math.ceil(difference / MINUTE);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  const parts = [
    days ? `${days}d` : "",
    hours ? `${hours}h` : "",
    minutes || (!days && !hours) ? `${minutes}m` : "",
  ].filter(Boolean);
  return `Starts in ${parts.join(" ")}`;
}
